/**
 * Vanilla JS Smooth Scroll for Anchors
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;

	// Get the header height for sticky headers
	const header = document.querySelector('.header');
	const headerHeight = header ? header.offsetHeight : 0;

	// Smooth scrolling function with constant speed
	function smoothScroll(target, duration = 800) {
		const start = window.scrollY || window.pageYOffset;
		const end = target.getBoundingClientRect().top + start - headerHeight;
		const distance = end - start;
		const speed = Math.abs(distance) / duration; // Constant speed
		let startTime = null;

		function animation(currentTime) {
			if (!startTime) startTime = currentTime;
			const timeElapsed = currentTime - startTime;
			const progress = timeElapsed / duration;
			const nextPosition = start + distance * progress;

			window.scrollTo(0, nextPosition);

			if (timeElapsed < duration) {
				requestAnimationFrame(animation);
			} else {
				window.scrollTo(0, end);
				target.focus();
			}
		}

		requestAnimationFrame(animation);
	}

	// Validate selector before using querySelector
	function isValidSelector(selector) {
		return selector && selector.startsWith('#') && selector.length > 1 && !/^\d/.test(selector.slice(1));
	}

	// Handle page load with hash scrolling
	if (window.location.hash && isValidSelector(window.location.hash)) {
		const target = document.querySelector(window.location.hash);
		if (target) {
			setTimeout(() => smoothScroll(target), 300);
		}
	}

	// Add click event for anchor links
	document.querySelectorAll('a.js-anchor-link').forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();
			const hash = this.getAttribute('href');

			if (isValidSelector(hash)) {
				const target = document.querySelector(hash);
				if (target) {
					smoothScroll(target);
				}
			}
		});
	});
};
